import React, { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';
import Loading from '../../Loading';
import AdvancedFilter from '../AdvancedFilter';
import { useAdvancedCurrentPeopleFilter } from './context';
import { fromApiFilter, toApiFilter } from './model';
import { ApiGroup } from './types';

type Props = {
  value: ApiGroup | undefined;
  onChange?: (value: ApiGroup | undefined) => void;
  onValidChange?: (message: string | null) => void;
  disabled?: boolean;
  required?: boolean;
  searchBarPlaceholder?: string;
};

const AdvancedCurrentPeopleApiFilter: FC<Props> = ({
  disabled = false,
  required = false,
  value,
  onChange,
  onValidChange,
  searchBarPlaceholder,
}) => {
  const { suggestions, selectedSuggestionConverter } =
    useAdvancedCurrentPeopleFilter();
  const { formatMessage } = useIntl();

  const handleOnChange = useCallback(
    (filters) => {
      onChange?.(toApiFilter(filters, false));
    },
    [onChange]
  );

  const transformedValue =
    value && suggestions
      ? fromApiFilter(suggestions, selectedSuggestionConverter, value)
      : undefined;

  if (!suggestions) {
    return (
      <Loading
        message={formatMessage({
          id: 'app.views.widgets.inputs.people_include_exclude_filter.message.loading_filters',
          defaultMessage: 'Loading filters...',
        })}
      />
    );
  }

  return (
    <AdvancedFilter
      disabled={disabled}
      required={required}
      suggestions={suggestions}
      suggestionForConditionConverter={selectedSuggestionConverter}
      value={transformedValue}
      onChange={handleOnChange}
      onValidChange={onValidChange}
      searchBarPlaceholder={searchBarPlaceholder}
    />
  );
};

export default React.memo(AdvancedCurrentPeopleApiFilter);
